import { Image } from '@mantine/core';

interface GTILogoProps {
  width?: number;
}
export function GTILogo({ width = 120 }: Readonly<GTILogoProps>) {
  return <Image src="/assets/gti/logo-primary-light.svg" width={width} />;
}
